import { useRef, useState } from "react";

/* ---------------------------------------------------------------
   VIP LINKS — GET user/vip-links (Bearer token via authFetch).
   Backend contract: { vip_chat: "<url>" | null, vip_channel: "<url>" | null,
                     conference_channel: "<url>" | null }
   conference_channel is null while the admin switch is off.

   Unlike useCourses, this does NOT fetch on mount — the card sits in
   the profile from the start showing a "Generate" button, and the
   request only fires once the user taps it. Calling generate() again
   afterwards just re-fetches (handy if the admin only just set the
   links and the first call came back empty).
------------------------------------------------------------------ */
export function useVipLinks(authFetch) {
  const [status, setStatus] = useState("idle"); // idle | loading | ready | error
  const [links, setLinks] = useState({ vipChat: null, vipChannel: null, conferenceChannel: null });
  const reqIdRef = useRef(0);

  const generate = () => {
    if (!authFetch) return;
    const reqId = ++reqIdRef.current;
    setStatus("loading");
    authFetch("user/vip-links", { method: "GET" })
      .then((res) => {
        if (!res.ok) throw new Error(`vip-links API ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (reqIdRef.current !== reqId) return; // superseded by a newer call
        setLinks({
          vipChat: data?.vip_chat || null,
          vipChannel: data?.vip_channel || null,
          conferenceChannel: data?.conference_channel || null,
        });
        setStatus("ready");
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.error("[useVipLinks] failed to load VIP links:", e);
        if (reqIdRef.current !== reqId) return;
        setStatus("error");
      });
  };

  return { status, ...links, generate };
}
